import React from 'react';

import {Icon, Text} from '@albert-io/atomic';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

interface Props {
  copy: string;
  icon: IconProp;
}

export default function TabEmptyState({copy, icon}: Props) {
  return (
    <div className='flex flex-col items-center justify-center gap-x2 rounded-x1 border border-subtle p-x4'>
      <div className='flex h-x8 w-x8 items-center justify-center rounded-full background-bold p-x1-half'>
        <Icon className='text-xxl' color='tertiary' icon={icon} />
      </div>
      <Text color='secondary'>{copy}</Text>
    </div>
  );
}
